"use client"
import "@/styles/auth.css"
import { Button } from "@/components/shared/ui/button";
import { Card, CardContent } from "@/components/shared/ui/card";
import { Input } from "@/components/shared/ui/input";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { Facebook, Globe, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Textarea } from "@/components/shared/ui/textarea";
import ScrollFadeIn from "@/components/shared/animations/ScrollFadeIn";
import { drAndCoachStaticData } from "@/constants/drAndCoachData";
import axiosInstance from "@/lib/axiosInstance";
import toast from "react-hot-toast";

const ContactPage = () => {
    const t = useTranslations("Auth.contact");
    const [form, setForm] = useState({
        name: "",
        email: "",
        message: ""
    });

    const [isLoading, setIsLoading] = useState(false);

    const handleSend = async (e: any) => {
        e.preventDefault()

        try {

            setIsLoading(true)
            await axiosInstance.post("/contact-us", form);

            setIsLoading(false)
            toast.success("Message sent successfully")
            setForm({
                name: "",
                email: "",
                message: ""
            })

        } catch (error) {
            console.log(error);
            toast.error("Error sending message")
        } finally {
            setIsLoading(false)
        }

    }

    return (
        <ScrollFadeIn>
            <div className="w-full h-full flex flex-col-reverse md:flex-row gap-12 py-12 px-4 md:px-12 lg:px-28 items-center">
                <Card className="w-full md:w-1/2 p-4">
                    <CardContent className="space-y-5">
                        <div className="space-y-2">
                            <label className="text-right block text-sm font-medium">{t("name")}</label>
                            <Input
                                required={true}
                                type="text"
                                placeholder={t("name")}
                                className="text-right rounded-xl py-6"
                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                                value={form.name}
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="text-right block text-sm font-medium">{t("email")}</label>
                            <Input
                                required={true}
                                type="email"
                                placeholder={t("email")}
                                className="text-right rounded-xl py-6"
                                onChange={(e) => setForm({ ...form, email: e.target.value })}
                                value={form.email}
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="text-right block text-sm font-medium">{t("message")}</label>
                            <Textarea
                                required={true}
                                placeholder={t("messagePlaceHolder")}
                                className="text-right rounded-xl py-6"
                                onChange={(e) => setForm({ ...form, message: e.target.value })}
                                value={form.message}
                            />
                        </div>

                        <Button onClick={handleSend} type="submit" disabled={isLoading} variant="sub_primary" className="w-full rounded-xl p-5">
                            {isLoading ? "...loading" : t("send")}
                        </Button>
                    </CardContent>
                </Card>

                <div className="flex flex-col items-center gap-12 w-full md:w-1/2">
                    <h1 className="font-bold text-3xl">{t("contactUs")}</h1>

                    <div className="w-[230px] h-[230px]">
                        <img className="w-full h-full object-cover" src="/contact.webp" alt="Contact Us" />
                    </div>

                    <div className="w-full flex items-center justify-center flex-wrap lg:flex-nowrap gap-4">
                        <div className="flex items-center gap-1.5">
                            <MapPin className="w-6 h-6 text-primary" />
                            <span className="text-sm">
                                {drAndCoachStaticData.address}
                            </span>
                        </div>
                        <div className="flex items-center gap-1.5">
                            <Phone className="w-6 h-6 text-primary" />
                            <span className="text-sm">
                                {drAndCoachStaticData.phone}
                            </span>
                        </div>
                        <div className="flex items-center gap-1.5">
                            <Mail className="w-6 h-6 text-primary" />
                            <span className="text-sm">
                                {drAndCoachStaticData.email}
                            </span>
                        </div>
                    </div>

                    <div className="flex items-center w-full gap-3 justify-center">
                        {/* <a target="_blank" href={drAndCoachStaticData.facebook}><Globe className="w-6 h-6 cursor-pointer text-sub_text_color hover:text-primary" /></a> */}
                        <a target="_blank" href={drAndCoachStaticData.linkedIn}><Linkedin className="w-6 h-6 cursor-pointer text-sub_text_color hover:text-primary" /></a>
                        <a target="_blank" href={drAndCoachStaticData.facebook}><Facebook className="w-6 h-6 cursor-pointer text-sub_text_color hover:text-primary" /></a>
                        <a target="_blank" href={drAndCoachStaticData.twitter}><Twitter className="w-6 h-6 cursor-pointer text-sub_text_color hover:text-primary" /></a>
                        <a target="_blank" href={drAndCoachStaticData.instagram}><Instagram className="w-6 h-6 cursor-pointer text-sub_text_color hover:text-primary" /></a>
                    </div>
                </div>
            </div>
        </ScrollFadeIn>
    );
};

export default ContactPage;